namespace $.$$ {
    $mol_style_define($bog_theme_picker, {
        background: {
            color: $mol_theme.back,
        },
        borderRadius: '8px',
        overflow: 'hidden',
        opacity: 1,
        Search: {
            borderRadius: '8px',
        },
    })
}
